import axiosInstance from 'api/axiosInstance'

export const getScheduledContent = async (type?: string) => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: '/api/user/schedules',
        params: type
            ? {
                  type
              }
            : undefined
    })

    return data?.data
}

export const postContentNow = async (id: string) => {
    const { data } = await axiosInstance({
        method: 'PUT',
        url: `/api/user/schedules/${id}/post-now`
    })

    return data
}

export const deleteScheduledPostFn = async (id: string) => {
    const { data } = await axiosInstance({
        method: 'DELETE',
        url: `/api/user/schedules/${id}`
    })

    return data
}
